import {BaseCachedService} from './Core/BaseCachedService';
import {BaseService} from "./Core/BaseService";
import {ObjectUtils, FileUtils} from "../Utils";

class ReportService extends BaseCachedService {
    get Url() { return super.Url + "/reports"; }

    Get(programId = null, projectId = null, sampleEventPhaseId = null) {
        let request = {programId, projectId, sampleEventPhaseId};
        return this.SendRequest(BaseService.GET, request);
    }

    DownloadPhotos(projectId = null, sampleEventId = null) {
        return this.DownloadFile({
            projectId, sampleEventIds: sampleEventId.join(',')
        }, '/photos');
    }

    Print(parameters) {
        return this.DownloadFile(parameters);
    }
    
    async DownloadFile(data, suffix = '') {
        this.SetLoading();

        try {
            await FileUtils.SaveFileDownload(
                fetch(`${this.Url}${suffix}`, {
                    method: 'POST',
                    headers: {'Authorization': BaseService.AUTH_TOKEN },
                    body: ObjectUtils.BuildFormData(data),
                })
            );
        } catch (error) {
            alert(error);
        } finally {
            this.SetLoading(false);
        }
    }
}

export const service = new ReportService();

